import { useEffect, useState } from "react";
import { useFormModal } from "@/react/components/FormRenderer/FormModal";
import type { ElementType } from "@/react/types/Element";
import type { Form } from "@/react/types/Form";
import { useModalCookie } from "../hooks/useModalCookie";

interface ModalCountdownProps {
  form: Form;
  formElements: ElementType[];
  index: number;
  popupDelay: number;
  popupFrequency: number;
}
export const useModalCountdown = ({
  form,
  index,
  popupDelay,
  popupFrequency,
  formElements,
}: ModalCountdownProps) => {
  const [countdown, setCountdown] = useState(popupDelay);
  const formModal = useFormModal();
  const { shouldSuppressPopupForm, suppressPopupForm } = useModalCookie({
    form,
    popupFrequency,
  });

  useEffect(() => {
    if (shouldSuppressPopupForm) return;
    if (countdown === 0) {
      void formModal.show({
        form,
        index,
        formElements,
        isPreview: false,
        handleModalClose: suppressPopupForm,
      });
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prevCountdown => {
        if (prevCountdown <= 1) {
          // eslint-disable-next-line sonarjs/post-message -- Disabled for plugin version update. Fix when possible.
          window.parent.postMessage(
            {
              type: "resize",
              formUid: form.uid,
              formIndex: index,
              height: "100vh",
            },
            "*",
          );
        }
        return prevCountdown - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [form, formElements, popupDelay, countdown]);

  return {
    countdown,
  };
};
